import React from 'react'
import Accordion, { AccordionProps } from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { ChevronDown } from 'react-feather'
import styled, { useTheme } from 'styled-components'
import { Flex } from '../Flex'

export enum ArrowPosition {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom'
}

interface InfoAccordionProps extends AccordionProps {
  children: NonNullable<React.ReactNode>
  description: React.ReactNode
  expandIcon?: React.ReactNode
  arrowPosition?: ArrowPosition
  withBorder?: boolean
}
const StyledAccordion = styled(Accordion)<{ arrowPosition?: ArrowPosition; withBorder?: boolean }>`
  &.MuiPaper-root {
    background-color: ${({ withBorder, theme }) => (withBorder ? 'transparent' : theme.colors.gray10)};
    border: ${({ withBorder, theme }) => (withBorder ? `1px solid ${theme.colors.gray7}` : 'none')};
    padding: ${({ withBorder }) => (withBorder ? '8px' : '8px 16px')};
    box-shadow: none;
    border-radius: 8px !important;
    width: 100%;
    margin: 0;
    background-color: tansparent !important;
    color: ${({ theme }) => theme.colors.text};
    font-size: 12px;
    font-weight: 600;
  }
  &.Mui-disabled {
    background-color: transparent !important;
  }
  .MuiAccordionSummary-root {
    padding: 0;
    align-items: ${({ arrowPosition = ArrowPosition.MIDDLE }) => {
      switch (arrowPosition) {
        case ArrowPosition.TOP:
          return 'flex-start'
        case ArrowPosition.BOTTOM:
          return 'flex-end'
        default:
          return 'center'
      }
    }};
  }

  div.MuiAccordionSummary-content {
    margin: 0;
  }
  &:before {
    display: none;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }

  .MuiAccordionSummary-expandIconWrapper {
    margin-bottom: ${({ arrowPosition }) => {
      switch (arrowPosition) {
        case ArrowPosition.BOTTOM:
          return '8px'
        default:
          return '0px'
      }
    }};
  }
`

const InfoAccordion: React.FC<InfoAccordionProps> = ({ children, description, expandIcon, ...props }) => {
  const theme = useTheme()

  return (
    <StyledAccordion disableGutters square {...props}>
      <AccordionSummary
        expandIcon={
          React.isValidElement(expandIcon) ? (
            React.cloneElement(expandIcon)
          ) : (
            <Flex alignItems="center" gap="8px">
              <ChevronDown cursor="pointer" stroke={theme.colors.gray2} />
            </Flex>
          )
        }
      >
        {description}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  )
}

export default InfoAccordion
